import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnChanges {

  @Input() url?: SafeResourceUrl | string;
  @Input() pdfFile?: File | null;
  @Input() showFrame = false;
  @Input() mimeType?: string | null;
  @Output() closed = new EventEmitter<void>();


  safeUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    // If pdf is from form control
    if (this.pdfFile) {
      const blobUrl = URL.createObjectURL(this.pdfFile);
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    // if pdf is from url (server)
    } else if (this.url) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url as string);
    }
  }

  closePdfModal() {
    this.closed.emit();
  }
}
